import type { Route } from "./+types/schedule";

import { useTranslation } from "react-i18next";

import { ScheduleTable } from "../components/schedule-table";
import {
  DEFAULT_SCHEDULE,
  type ScheduleTable as ScheduleData,
} from "../lib/schedule-data";

export const meta: Route.MetaFunction = () => {
  return [
    { title: `Schedule | ${import.meta.env.VITE_APP_NAME}` },
    { name: "robots", content: "noindex, nofollow" },
  ];
};

// TODO: replace with a `loader` that fetches the schedule from the database
// once the admin schedule editor is added. The UI below depends only on the
// `ScheduleTable` shape.
function getSchedule(): ScheduleData {
  return DEFAULT_SCHEDULE;
}

export default function ProgramSchedulePage() {
  const { t } = useTranslation();
  const schedule = getSchedule();

  return (
    <main className="mx-auto w-full max-w-5xl px-4 py-8">
      <header className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">
          {t("programsPage.scheduleTitle")}
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          {t("programsPage.scheduleSubtitle")}
        </p>
      </header>

      <ScheduleTable schedule={schedule} />
    </main>
  );
}
